<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属车场" prop="spaceId">
              <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属区域" prop="regionId">
              <el-select
                v-model="form.regionId"
                disabled
                style="width:100%"
                placeholder="请选择所属区域"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.spaceName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位编号" prop="name">
              <el-input
                clearable
                disabled
                v-model="form.name"
                placeholder="车位编号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位面积" prop="area">
              <el-input
                clearable
                disabled
                v-model="form.area"
                placeholder="车位面积"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="子母车位" prop="isDouble">
              <el-select disabled v-model="form.isDouble" style="width:100%" placeholder="车位状态" clearable>
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位性质" prop="parkingSpaceNature">
              <el-select disabled v-model="form.parkingSpaceNature" style="width:100%" placeholder="车位性质" clearable>
                <el-option
                  v-for="item in parkingSpaceNatureDict"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车位状态" prop="spaceStatus">
              <el-select disabled v-model="form.spaceStatus" style="width:100%" placeholder="车位状态" clearable>
                <el-option
                  v-for="item in spaceStatusData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
            <el-form-item label="业主姓名" prop="personName">
              <el-input
                clearable
                disabled
                v-model="form.personName"
                placeholder="请输入业主姓名"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
            <el-form-item label="业主电话" prop="personPhone">
              <el-input
                disabled
                clearable
                v-model="form.personPhone"
                placeholder="请输入业主电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
            <el-form-item label="楼栋/单元" prop="buildingId">
              <el-select disabled v-model="form.buildingId" style="width:100%" placeholder="请选择楼栋/单元">
                <el-option
                  v-for="item in buildingList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
            <el-form-item label="房间名称" prop="roomId">
              <el-select  disabled v-model="form.roomId" style="width:100%" placeholder="请选择房间名称">
                <el-option
                  v-for="item in roomList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus ==2 || form.spaceStatus ==3">
            <el-form-item label="收费套餐" prop="feeRuleId">
              <el-select disabled v-model="form.feeRuleId" style="width:100%" placeholder="请选择收费套餐">
                <el-option
                  v-for="item in carRuleList"
                  :key="item.id"
                  :label="item.setmealName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="生效日期" prop="effectTime">
              <el-date-picker
                style="width:100%"
                v-model="form.effectTime"
                disabled
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择生效日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="失效日期" prop="expiredTime">
              <el-date-picker
                style="width:100%"
                v-model="form.expiredTime"
                disabled
                type="date"
                value-format="yyyy-MM-dd 23:59:59"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.spaceStatus == 2 || form.spaceStatus == 3">
            <el-form-item label="断缴日期" prop="breakTime">
              <el-date-picker
                style="width:100%"
                v-model="form.breakTime"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择断缴日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item  label="申请备注" prop="breakRemark">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="form.breakRemark"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="submitRecord" size="small">
        提交
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancelRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>

import {
  getParkList,
  getRegionList,
  getCarRuleList,
  getBuildingList,
  getRoomList,
  spaceDetail,
  breakApply,
} from './index.js';
export default {
  components: {  },
  props: {
    row: {
      default: {},
    },
    spaceId:{},
    model: {},
  },
  data() {
    return {
      spaceStatusData:[
        {
          dictKey:'1',
          dictValue:'空闲',
        },
        {
          dictKey:'2',
          dictValue:'已出售',
        },
        {
          dictKey:'3',
          dictValue:'已出租',
        },
      ],
      isDoubleData:[
        {
          dictKey:0,
          dictValue:'否',
        },
        {
          dictKey:1,
          dictValue:'是',
        },
      ],
      parkingSpaceNatureDict:[
        {
          dictKey: 1,
          dictValue:'车位',
        },
        {
          dictKey: 2,
          dictValue:'车库',
        },
      ],
      regionList:[],
      form: {
        spaceId:'',
        regionId:'',
        parkingSpaceNature: '',
        name :'',
        spaceStatus:'',
        isDouble:'',
        area:'',
        personName:'',
        personPhone :'',
        breakTime :'',
        breakRemark :'',
        roomId:'',
        buildingId:'',
        roomName:'',
        feeRuleId:'',
        certNo:'',
        cycleFlag:'',
        feeCycleNum:'',
        feeCycleType:''
      },
      formRules: {
        spaceId: [{ required: true, message: '所属车场不能为空', trigger: 'blur' }],
        regionId: [{ required: true, message: '所属区域不能为空', trigger: 'change' }],
        name: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
        spaceStatus: [{ required: true, message: '车位状态不能为空', trigger: 'blur' }],
        isDouble: [{ required: true, message: '子母车位不能为空', trigger: 'change' }],
        parkingSpaceNature: [{ required: true, message: '车位性质不能为空', trigger: 'change' }],
        personName  : [{ required: true, message: '业主姓名不能为空', trigger: 'change' }],
        personPhone: [{ required: true, message: '业主电话不能为空', trigger: 'change' }],
        roomId: [{ required: false, message: '房间名称不能为空', trigger: 'change' }],
        buildingId: [{ required: false, message: '楼栋/单元不能为空', trigger: 'change' }],
        feeRuleId: [{ required: false, message: '收费套餐不能为空', trigger: 'change' }],
        effectTime: [{ required: true, message: '生效日期不能为空', trigger: 'change' }],
        breakTime: [{ required: true, message: '断缴日期不能为空', trigger: 'change' }],
      },
      tableHeight: '',
      spaceIdList:[],
      carRuleList:[],
      buildingList:[],
      roomList:[],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
  },
  watch:{
  },
  methods: {
    initData() {
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
      spaceDetail({id:this.row.id}).then(res=>{
        this.form = res.data
        getRegionList({
          spaceId:this.form.spaceId
        }).then((res) => {
          this.regionList = res.data
        })
        this.getCarRuleList()
        this.getBuildingList()
        this.getRoomList()
      })
    },
    getCarRuleList() {
      getCarRuleList({spaceId:this.form.spaceId,packageType:2}).then((res) => {
        this.carRuleList = res.data
      })
    },
    getBuildingList(){
      getBuildingList({spaceId:this.form.spaceId}).then((res) => {
        this.buildingList = res.data
      })
    },
    getRoomList(){
      getRoomList({buildingId:this.form.buildingId}).then((res) => {
        this.roomList = res.data
      })
    },
    submitRecord() {
      console.log(this.form);
      console.log(this.$refs);
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          const breakApplyConst = {
            id:this.form.id,
            breakRemark:this.form.breakRemark,
            breakTime:this.form.breakTime,
          }
          breakApply(breakApplyConst).then((res) => {
            this.$message.success('申请成功');
            this.$emit('success');
          });
        }
      });
    },
    cancelRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
